

      
          jQuery(function() {
  var $module = jQuery('#m-1595555590352').children('.module');
  var activeTab = parseInt($module.attr('data-activeTab')) - 1;
  var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';

  $module.gfV3ResTabs({
      'activeTab': activeTab,
      'mode': mode,
      tabSelected: function(index) {
        var tabInactiveBgColor = $module.attr('data-inactiveTabBgColor');
        var tabInactiveColor = $module.attr('data-inactiveTabColor');
        var tabBgColor = $module.attr('data-tabBgColor');
        var tabColor = $module.attr('data-tabColor');
        var borderColor = $module.attr('data-borderColor');
        var borderSize = $module.attr('data-borderSize');

        var $gfTabs = $module.find('>ul>li.gf_tab');
        var $gfTabActive = $module.find('>ul>li.gf_tab-active');
        var $gfTabPanels = $module.find('>.gf_tab-panel');

        if($module.hasClass('style1')) {
          $gfTabs
            .css('margin-left', '-' + borderSize)
            .css('border', borderSize + ' solid ' + borderColor)
            .css('border-bottom', borderSize + ' solid ' + borderColor);

          $module.find('>ul>li.gf_tab:first').css('margin-left', '0px');

        } else if($module.hasClass('style3')) {
          $gfTabs.css('border-bottom', borderSize + ' solid ' + tabBgColor);
        }

        if(!$module.hasClass('style3')) {
          $gfTabs.css('background-color', tabInactiveBgColor);
          $gfTabActive.css('background-color', tabBgColor);
        }

        $gfTabs.css('color', tabInactiveColor);
        $gfTabActive.css('color', tabColor);

        if($module.hasClass('style1')) {
          $gfTabActive.children('.gf_tab-bottom')
          .css('backgroundColor', tabBgColor)
          .css('height', borderSize)
          .css('bottom', '-' + borderSize);
        } else if($module.hasClass('style3')) {
          $gfTabActive.children('.gf_tab-bottom')
          .css('backgroundColor', borderColor)
          .css('height', borderSize)
          .css('bottom', '-' + borderSize);
        }
        $gfTabPanels
        .css('top', '-' + borderSize)
        .css('background-color', tabBgColor)
        .css('border', '1px solid ' + borderColor);

        if($module.hasClass('style1')) {
          $gfTabPanels.css('border', borderSize + ' solid ' + borderColor);
        } else {
          $gfTabPanels.css('border', 'none');
        }
        // Fix (P) Desc read more bug	
        $module.find('.module-wrap[data-label="(P) Description"]').each(function(index, el) {	
            if (jQuery(el).children('.module').data('gfv3productdesc') != undefined) {	
                jQuery(el).children(".module").data("gfv3productdesc").initReadMore();	
            }	
        });
      }
  });
  if(mode == 'dev') {
    var moduleId = "1595555590352";
    var moduleIdSlug = moduleId.toString().replace(/-/g, '');
    if (moduleIdSlug == "1595555590352") {
      window.getTab1595555590352 = function() {
        return $module.data('gfv3restabs');
      }
    }
  }
});
      
      
      
      
      
      
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243').children('.module');

    var sameHeightTitle = $module.data('sameheightitle'),
        spacing = $module.data('spacing');
        collg = $module.data('collg'),
        colmd = $module.data('colmd'),
        colsm = $module.data('colsm'),
        colxs = $module.data('colxs');

    var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
    var col = collg;


    jQuery(window).resize(function() {
        setTimeout(function() {
            for(var i = 0; i < $clearfixes.length; i++) {
                if($clearfixes.eq(i).css('display') == 'block') {
                    if($clearfixes.eq(i).hasClass('visible-lg')) {
                        col = collg;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-md')) {
                        col = colmd;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-sm')) {
                        col = colsm;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-xs')) {
                        col = colxs;
                        break;
                    }
                }
            }
        }, 1000);
    });

    if(sameHeightTitle == '1') {
        var minHeight = 0;

        $module.find('.product-single__title').each(function() {
        });
    } else {
    }

    jQuery($module).css('padding', spacing);
});
      
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child1').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child1-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child1-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child1-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child2').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child2-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child2-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child2-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child3').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child3-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child3-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child3-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child4').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child4-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child4-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child4-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child5').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child5-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child5-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child5-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child6').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child6-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child6-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child6-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child7').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child7-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child7-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child7-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child8').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child8-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child8-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child8-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child9').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child9-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child9-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child9-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child10').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child10-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child10-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child10-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child11').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child11-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child11-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child11-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child12').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child12-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child12-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child12-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child13').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child13-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child13-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child13-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child14').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child14-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child14-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child14-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child15').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child15-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child15-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child15-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child16').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child16-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child16-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child16-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child17').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child17-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child17-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child17-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child18').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child18-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child18-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child18-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child19').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child19-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child19-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child19-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child20').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child20-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child20-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child20-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child21').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child21-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child21-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child21-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child22').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child22-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child22-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child22-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child23').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child23-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child23-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child23-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child24').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child24-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child24-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child24-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child25').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child25-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child25-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child25-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child26').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child26-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child26-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child26-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child27').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child27-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child27-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child27-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child28').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child28-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child28-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child28-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child29').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child29-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child29-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child29-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child30').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595555751243-child30-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595555751243-child30-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595555751243-child30-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
    var $module = jQuery('#m-1595555812145').children('.module');
    var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
    
    if (mode == 'dev') {
        var $paginator = $module.find('.gf_collection-paginator-wrapper');
        if ($paginator.length > 0) {
            var productCount = $paginator.attr('data-product-count');
            var previousText = $module.attr('data-previous');
            var nextText = $module.attr('data-next');
            var activeColor = $module.attr('data-active-color');      

            var applyEvents = function() {
                $paginator.children('span:not(.deco)').off('click').on('click', function() {
                    var currentPage = parseInt($paginator.children('.current').text()) - 1;
                
                    if (jQuery(this).hasClass('prev')) {
                        currentPage--;
                    } else if (jQuery(this).hasClass('next')) {
                        currentPage++;
                    } else {
                        currentPage = parseInt(jQuery(this).text()) - 1;
                    }
                    render(currentPage);
                })
            }

            var render = function(currentPage) {
                $paginator.html('');

                if (currentPage != 0) {
                    $paginator.append('<span class="prev">' + previousText + '</span>')
                }
                
                if (currentPage - 2 > 0) {
                    $paginator.append('<span class="page">1</span>');
                }

                if (currentPage -2 > 1) {
                    $paginator.append('<span class="deco">...</span>');
                }

                for (var i = Math.max(0, currentPage - 2); i <= Math.min(currentPage + 2, productCount - 1); i++) {
                    $paginator.append('<span class="page' + (currentPage == i ? ' current' : '') + '">' + (i + 1) + '</span>');
                }

                if (currentPage + 2 < productCount - 2) {
                    $paginator.append('<span class="deco">...</span>');
                }

                if (currentPage + 2 < productCount - 1) {
                    $paginator.append('<span class="page">' + productCount + '</span>');
                }

                if (currentPage != productCount - 1 && productCount != 0) {
                    $paginator.append('<span class="next">' + nextText + '</span>')
                }

                applyEvents();
            }

            render(0);
        }
    }
});
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028').children('.module');

    var sameHeightTitle = $module.data('sameheightitle'),
        spacing = $module.data('spacing');
        collg = $module.data('collg'),
        colmd = $module.data('colmd'),
        colsm = $module.data('colsm'),
        colxs = $module.data('colxs');

    var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
    var col = collg;


    jQuery(window).resize(function() {
        setTimeout(function() {
            for(var i = 0; i < $clearfixes.length; i++) {
                if($clearfixes.eq(i).css('display') == 'block') {
                    if($clearfixes.eq(i).hasClass('visible-lg')) {
                        col = collg;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-md')) {
                        col = colmd;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-sm')) {
                        col = colsm;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-xs')) {
                        col = colxs;
                        break;
                    }
                }
            }
        }, 1000);
    });

    if(sameHeightTitle == '1') {
        var minHeight = 0;

        $module.find('.product-single__title').each(function() {
        });
    } else {
    }

    jQuery($module).css('padding', spacing);
});
      
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child1').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child1-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child1-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child1-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child2').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child2-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child2-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child2-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child3').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child3-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child3-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child3-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child4').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child4-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child4-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child4-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child5').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child5-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child5-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child5-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child6').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child6-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child6-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child6-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child7').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child7-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child7-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child7-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child8').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child8-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child8-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child8-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child9').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child9-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child9-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child9-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child10').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child10-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child10-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child10-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child11').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child11-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child11-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child11-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child12').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child12-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child12-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child12-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child13').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child13-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child13-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child13-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child14').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child14-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child14-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child14-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child15').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child15-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child15-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child15-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child16').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child16-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child16-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child16-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child17').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child17-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child17-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child17-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child18').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557005028-child18-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557005028-child18-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557005028-child18-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748').children('.module');

    var sameHeightTitle = $module.data('sameheightitle'),
        spacing = $module.data('spacing');
        collg = $module.data('collg'),
        colmd = $module.data('colmd'),
        colsm = $module.data('colsm'),
        colxs = $module.data('colxs');

    var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
    var col = collg;


    jQuery(window).resize(function() {
        setTimeout(function() {
            for(var i = 0; i < $clearfixes.length; i++) {
                if($clearfixes.eq(i).css('display') == 'block') {
                    if($clearfixes.eq(i).hasClass('visible-lg')) {
                        col = collg;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-md')) {
                        col = colmd;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-sm')) {
                        col = colsm;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-xs')) {
                        col = colxs;
                        break;
                    }
                }
            }
        }, 1000);
    });

    if(sameHeightTitle == '1') {
        var minHeight = 0;

        $module.find('.product-single__title').each(function() {
        });
    } else {
    }

    jQuery($module).css('padding', spacing);
});
      
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child1').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child1-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child1-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child1-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child2').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child2-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child2-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child2-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child3').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child3-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child3-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child3-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child4').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child4-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child4-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child4-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child5').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child5-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child5-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child5-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child6').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child6-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child6-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child6-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child7').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child7-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child7-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child7-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child8').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child8-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child8-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child8-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child9').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557099748-child9-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557099748-child9-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557099748-child9-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
    var $module = jQuery('#m-1595557167890').children('.module');

    var sameHeightTitle = $module.data('sameheightitle'),
        spacing = $module.data('spacing');
        collg = $module.data('collg'),
        colmd = $module.data('colmd'),
        colsm = $module.data('colsm'),
        colxs = $module.data('colxs');

    var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
    var col = collg;


    jQuery(window).resize(function() {
        setTimeout(function() {
            for(var i = 0; i < $clearfixes.length; i++) {
                if($clearfixes.eq(i).css('display') == 'block') {
                    if($clearfixes.eq(i).hasClass('visible-lg')) {
                        col = collg;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-md')) {
                        col = colmd;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-sm')) {
                        col = colsm;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-xs')) {
                        col = colxs;
                        break;
                    }
                }
            }
        }, 1000);
    });

    if(sameHeightTitle == '1') {
        var minHeight = 0;

        $module.find('.product-single__title').each(function() {
        });
    } else {
    }

    jQuery($module).css('padding', spacing);
});
      
      
          jQuery(function() {
  var $module = jQuery('#m-1595557167890-child1').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557167890-child1-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557167890-child1-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557167890-child1-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557167890-child2').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557167890-child2-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557167890-child2-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557167890-child2-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557167890-child3').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557167890-child3-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557167890-child3-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557167890-child3-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
    var $module = jQuery('#m-1595557217157').children('.module');

    var sameHeightTitle = $module.data('sameheightitle'),
        spacing = $module.data('spacing');
        collg = $module.data('collg'),
        colmd = $module.data('colmd'),
        colsm = $module.data('colsm'),
        colxs = $module.data('colxs');

    var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
    var col = collg;


    jQuery(window).resize(function() {
        setTimeout(function() {
            for(var i = 0; i < $clearfixes.length; i++) {
                if($clearfixes.eq(i).css('display') == 'block') {
                    if($clearfixes.eq(i).hasClass('visible-lg')) {
                        col = collg;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-md')) {
                        col = colmd;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-sm')) {
                        col = colsm;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-xs')) {
                        col = colxs;
                        break;
                    }
                }
            }
        }, 1000);
    });

    if(sameHeightTitle == '1') {
        var minHeight = 0;

        $module.find('.product-single__title').each(function() {
        });
    } else {
    }

    jQuery($module).css('padding', spacing);
});
      
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child1').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557217157-child1-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child1-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557217157-child1-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child2').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557217157-child2-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child2-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557217157-child2-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child3').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557217157-child3-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child3-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557217157-child3-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child4').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557217157-child4-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child4-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557217157-child4-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child5').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557217157-child5-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557217157-child5-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557217157-child5-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
    var $module = jQuery('#m-1595557252567').children('.module');

    var sameHeightTitle = $module.data('sameheightitle'),
        spacing = $module.data('spacing');
        collg = $module.data('collg'),
        colmd = $module.data('colmd'),
        colsm = $module.data('colsm'),
        colxs = $module.data('colxs');

    var $clearfixes = $module.find('.gf_row-no-padding').children('.gf_clearfix');
    var col = collg;


    jQuery(window).resize(function() {
        setTimeout(function() {
            for(var i = 0; i < $clearfixes.length; i++) {
                if($clearfixes.eq(i).css('display') == 'block') {
                    if($clearfixes.eq(i).hasClass('visible-lg')) {
                        col = collg;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-md')) {
                        col = colmd;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-sm')) {
                        col = colsm;
                        break;
                    }
                    if($clearfixes.eq(i).hasClass('visible-xs')) {
                        col = colxs;
                        break;
                    }
                }
            }
        }, 1000);
    });

    if(sameHeightTitle == '1') {
        var minHeight = 0;

        $module.find('.product-single__title').each(function() {
        });
    } else {
    }

    jQuery($module).css('padding', spacing);
});
      
      
          jQuery(function() {
  var $module = jQuery('#m-1595557252567-child1').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557252567-child1-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557252567-child1-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557252567-child1-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557252567-child2').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557252567-child2-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557252567-child2-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557252567-child2-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
          jQuery(function() {
  var $module = jQuery('#m-1595557252567-child3').children('.module');
  $module.gfV3Product();
}); 
      
          jQuery(function() {
    var $module = jQuery('#m-1595557252567-child3-0').children('.module');
    var effect = $module.attr('data-effect');
    $module.gfV3ProductImage({
        'effect': effect
    })
});
      
          jQuery(function() {
  var $module = jQuery('#m-1595557252567-child3-1').children('.module');
});
      
          jQuery(function() {
        var $module = jQuery('#m-1595557252567-child3-2').children('.module');
        $module.gfV3ProductPrice({
            displayCurrency: true
        });
    });
      
    jQuery(function() {
        var $module = jQuery('#m-1595554431132').children('.module');
        $module.gfV1Instagram();
    });
  
var gemFlag=!1;for(var i=0;i<pageLibs.length;i++){if(pageLibs[i].indexOf('gfv3product.js')!==-1){if(jQuery.gfV3Product==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfv3restabs.js')!==-1){if(jQuery.gfV3ResTabs==undefined){gemFlag=!0;break}}if(pageLibs[i].indexOf('gfaccordion.js')!==-1){if(jQuery.gfAccordion==undefined){gemFlag=!0;break}}}if(gemFlag){var count=0;for(var i=0;i<pageLibs.length-1;i++){jQuery.getScript(pageLibs[i],function(){count++;if(count==pageLibs.length-1){jQuery.getScript(pageLibs[pageLibs.length-1],function(){})}})}}